import React from 'react';
import './Assets'

const  ContextMenu=(props)=>{
    
    const deleteAction=async(userID)=>{
        props.onDeleteClick(userID);
    }

    const editAction=async(userID)=>{
        props.onEditClick()
        console.log(userID)
    }

    return(
    <>
    <div className='card-column-auto'>
        <div className='adaction-list'>
            <ul>
                <li><button type='button' onClick={() => deleteAction(props.id)} >Delete</button></li>
                <li><button type='button' onClick={() => editAction(props.id)}>Edit</button></li>
            </ul>
        </div>
    </div>
    </>
    )
}

export default ContextMenu;